export class DialogModelLogisticsCollect {
    constructor(
      public invoiceData: any
    ) {}
  }